import { PageHeader } from '@/components/ui';
import { InviteCard } from '@/features/referrals/InviteCard';

/** Share the platform: the student's invite link and who joined through it. */
export function StudentInvitePage() {
  return (
    // On a phone or tablet held upright the card runs to the bottom of the
    // screen.
    <div className="flex flex-col portrait:flex-1">
      <PageHeader
        title="Social & referral"
        description="Share Join-Wonder with friends looking for an internship, and see who joined."
      />
      <div className="flex max-w-3xl flex-1 flex-col portrait:max-w-none">
        <InviteCard className="flex-1" />
      </div>
    </div>
  );
}
